// extracted by mini-css-extract-plugin
export var client_logo_LeftBox = "cliensPartners-module--client_logo_LeftBox--ad778";
export var client_logo_rightBox = "cliensPartners-module--client_logo_rightBox--4701a";
export var client_logo_wrap = "cliensPartners-module--client_logo_wrap--60ea2";
export var client_partner_Leftbox = "cliensPartners-module--client_partner_Leftbox--5ca8f";
export var client_partner_wrap = "cliensPartners-module--client_partner_wrap--4192b";
export var slider_box = "cliensPartners-module--slider_box--339a6";